<template>
  <div class="q-pa-md">
    <div class="row">
      <div class="col-6 q-pa-sm" v-for="(item, index) in templates" :key="index">
        <q-card class="full-height flex flex-center q-pa-lg" @click="selectTemplate(item)">
          <q-img :src="item.img" />
          <q-radio
            dense
            v-model="selectedTemplateInternal"
            :val="item"
            @update:model-value="checkRadio"
            class="absolute"
            style="top: 2px; right: 2px"
          />
        </q-card>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { IRichMenuContent, IRichMenuTemplate, IRichMenuTemplateCompact } from '@/utils/types'
import richMenuTemplate from '@/utils/richmenu-template.json'

@Options({
  emits: ['onSelectTemplate'],
})
export default class TemplateSelector extends Vue {
  @Prop()
  selectedTemplate!: IRichMenuTemplate

  @Prop()
  selectedTemplateCompact!: IRichMenuTemplateCompact

  @Prop()
  visible!: boolean

  @Prop()
  richMenuContent!: IRichMenuContent

  selectedTemplateInternal: IRichMenuTemplate | null = null

  templates: IRichMenuTemplate[] = richMenuTemplate

  async selectTemplate(item: IRichMenuTemplate) {
    if (!this.richMenuContent.image_url) {
      if (item.content?.length) {
        item.content.forEach((item) => {
          item.src = ''
        })
      }
    }
    this.selectedTemplateInternal = item
    this.$emit('onSelectTemplate', item)
  }

  async checkRadio(value) {
    await this.selectTemplate(value)
  }

  @Watch('selectedTemplateCompact')
  @Watch('visible')
  async setupTemplate() {
    if (this.visible) {
      if (this.selectedTemplateCompact._id) {
        const index = this.templates.findIndex((template) => this.selectedTemplateCompact._id === template._id)
        const item = this.templates[index]
        await this.checkRadio(item)
      }
    }
  }

  mounted() {
    this.selectedTemplateInternal = this.selectedTemplate
    this.setupTemplate()
  }
}
</script>

<style scoped lang="scss">
</style>
